import { render, staticRenderFns } from "./StudentOrders.vue?vue&type=template&id=8270b80e"
import script from "./StudentOrders.vue?vue&type=script&lang=js"
export * from "./StudentOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports